module.exports = __webpack_public_path__ + "static/assets/a310298db2edf4fbae8edefa88fa5814.svg";